import React, { forwardRef } from "react";
import { styled } from "@linaria/react";
import { SCREEN_SIZE } from "@static/screen-size";

const Typo = styled.p<TextProps>`
  text-align: ${(props) => (props.align ? props.align : "left")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : props.variant === "title" ? "18px" : "14px")};
  color: ${(props) =>
    props.color
      ? props.color
      : "#434343"};
  font-weight: ${(props) =>
    props.fontWeight 
      ? props.fontWeight
      : props.variant === "description" ||  props.variant === "base"
      ? 400
      : 600};
  line-height: ${(props) =>
    props.variant === "description" ? "22px" : ""};
  max-width: ${(props) => (props.maxWidht ? props.maxWidht + "px" : "unset")};
  margin: ${(props) => (props.margin ? props.margin : "0px")};
  padding: ${(props) => (props.padding ? props.padding : "0px")};

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: ${(props) => (props.fontSize ? props.fontSize : props.variant === "title" ? "28px" :  props.variant === "base" ? "14px" : "16px")};
  }
`;

export interface TextProps {
  variant: "base" | "title" | "description";
  align?: "left" | "center" | "right";
  color?: string;
  fontWeight?: number;
  maxWidht?: number;
  children: any;
  theme?: any;
  margin?: string;
  padding?: string;
  textClass?: string;
  fontSize?: string;
}

const Text = forwardRef<HTMLDivElement, TextProps>(
  ({ ...props }: TextProps, ref) => {
    return <Typo {...props} className={props.textClass ? props.textClass : ""}>{props.children}</Typo>;
  }
);

Text.defaultProps = {
  variant: "title",
  align: "left",
  children: "",
};
export { Text };
